module.exports = __webpack_public_path__ + "c95f2a6a3fcb65ca8071a1b9bc8b8bda.pdf";